import { memo } from 'react'
import { usePress } from '@react-aria/interactions'
import cn from 'classnames'

import { Icon } from '~/shared/ui/Icon'

import { ICON_BUTTON_ICON_SIZE, ICON_BUTTON_SIZE } from './config'
import type { IconButtonProps } from './types'

import styles from './IconButton.module.scss'

/** Квадратная/круглая кнопка-иконка. Из макета §20: 44×44, радиус 14≈$radius-sm. */
export const IconButton = memo(function IconButton(props: IconButtonProps) {
  const {
    iconName,
    size = 'M',
    iconSize,
    shape = 'SQUARE',
    variant = 'SECONDARY',
    isDisabled = false,
    ariaLabel,
    onPress,
  } = props

  const { pressProps, isPressed } = usePress({ onPress, isDisabled })
  const side = ICON_BUTTON_SIZE[size]

  return (
    <button
      className={cn(styles.root, styles[`shape_${shape}`], styles[`variant_${variant}`])}
      type='button'
      aria-label={ariaLabel}
      aria-disabled={isDisabled || undefined}
      data-pressed={isPressed}
      style={{ width: side, height: side }}
      {...pressProps}
    >
      <Icon name={iconName} size={iconSize ?? ICON_BUTTON_ICON_SIZE[size]} />
    </button>
  )
})
